import { reactive, watch } from 'vue';
import { useScroll } from '@seb-platform/shared/composables';

type HeaderState = {
  preventSlide: boolean;
  collapsed: boolean;
  dimmed: boolean;
  menuOpen: boolean;
  topReached: boolean;
  hasTabs: boolean;
};

const state = reactive<HeaderState>({
  preventSlide: false,
  collapsed: false,
  dimmed: false,
  menuOpen: false,
  topReached: true,
  hasTabs: false,
});

const { disableScroll, enableScroll } = useScroll();

watch(
  () => state.menuOpen,
  () => {
    /* tbd */
    if (state.menuOpen) {
      disableScroll();
    } else {
      enableScroll();
    }
  }
);

export function useHeader() {
  return {
    state,
  };
}
